import { Component, OnInit } from '@angular/core';
import { AtlasService } from './atlas.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { AtlasHeroPanelComponent } from './atlas-hero-panel/atlas-hero-panel.component';
import { CommonCompaniesPanelComponent } from 'src/app/shared/components/companies-panel/companies-panel.component';
import { AtlasEmbeddedCollectionComponent } from './atlas-embedded-collection/atlas-embedded-collection.component';
import { CommonDiscoverWhyComponent } from 'src/app/shared/components/discover-why/discover-why.component';
import { CommonFaqComponent } from 'src/app/shared/components/faq/faq-on.component';
import { CommonReadyToComponent } from 'src/app/shared/components/ready-to/ready-to.component';
import { CommonExploreGlobalPanelComponent } from 'src/app/shared/components/explore-global-panel/explore-more.component';
import { CommonLatestNewsComponent } from 'src/app/shared/components/latest-news/latest-news.component';
import { AtlasPaymentDigitalPlatformComponent } from './atlas-payment-digital-platform/altas-payment-digital-platform.component';
import { AtlasReadyToComponent } from './atlas-ready-to/atlas-ready-to.component';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-atlas',
  templateUrl: './atlas.component.html',
  styleUrls: ['./atlas.component.scss'],
  imports: [
    AtlasHeroPanelComponent,
    CommonCompaniesPanelComponent,
    AtlasEmbeddedCollectionComponent,
    AtlasPaymentDigitalPlatformComponent,
    AtlasReadyToComponent,
    CommonDiscoverWhyComponent,
    CommonFaqComponent,
    CommonReadyToComponent,
    CommonExploreGlobalPanelComponent,
    CommonLatestNewsComponent,
  ],
})
export class AtlasComponent implements OnInit {
  companiesData:any;
  discoverData:any;
  faqData:any;
  newsList:any;
  readyToData:any;
  exploreMore:any;
  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: ''
  }
  constructor(
    private atlasPageService: AtlasService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url 
  }

  ngOnInit(): void {
    this.loadDataAndSetCanonical();
    //this.blockParameterLessAccess();
  }

  loadDataAndSetCanonical() {
    this.atlasPageService.getAtlasLandingPageData();
    this.meta.updateMeta(
      this.route.snapshot.data?.['seo']?.[0]?.fields?.seoMetadataReference
        ?.fields
    );
    this.canonical.setCanonicalURL();
    let data = this.route.snapshot.data?.['seo']?.[0]?.fields;
    this.metaBody.title = data?.seoMetadataReference?.fields.title || 'Verto: Cross-border payments platform for businesses';
    this.metaBody.description = data?.seoMetadataReference?.fields.description || 'Verto: Cross-border payments platform for businesses across the globe.';
    this.metaBody.type = 'Verto Atlas';
    this.metaBody.url = this.getUrl;
    this.metaBody.image = data?.psHeroPanel?.fields?.image[0]?.fields?.file?.url;
    this.meta.updateOG(this.metaBody);
    this.atlasPageService.customerStats$.subscribe(data => {
      if (data != null) {
        this.companiesData = data?.fields?.components.map(
          (i:any) => i?.fields?.image?.fields?.file?.url
        );
      }
    });
    this.atlasPageService.customerStory$.subscribe(data => {
      if (data != null) {
        this.discoverData = data?.fields;
      }
    });
    this.atlasPageService.faq$.subscribe(data => {
      if (data != null) {
        this.faqData = data?.fields;
      }
    });
    this.atlasPageService.newsList$.subscribe(data => {
      if (data != null) {
        this.newsList = data?.[0]?.fields;
      }
    });
    this.atlasPageService.readyTo$.subscribe(data => {
      if (data != null) {
        this.readyToData = data;
      }
    });
    this.atlasPageService.exploreMore$.subscribe(data => {
      if (data != null) {
        this.exploreMore = data;
      }
    });

    this.posthogService.capturePageViewEvent('atlas');
  }
}
